
<template>
  <div
    class="overlay"
    style="z-index: 10001;"/>
</template>
<script>
export default {
  name: 'overlay',
}

</script>
<style lang="scss" scoped>
.overlay {
  pointer-events: auto;
  border-radius: inherit;
  bottom: 0;
  height: 100%;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-transition: inherit;
  transition: inherit;
  width: 100%;
  will-change: opacity;
  opacity: 0.46;
  background-color: rgb(33, 33, 33);
  border-color: rgb(33, 33, 33);
  z-index: 10001;
}
</style>
